import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=966280d8&scoped=true&lang=pug&"
import script from "./Page404.vue?vue&type=script&lang=js&"
export * from "./Page404.vue?vue&type=script&lang=js&"
import style0 from "./Page404.vue?vue&type=style&index=0&id=966280d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966280d8",
  null
  
)

export default component.exports